module.exports = __webpack_public_path__ + "static/GT-Super-Text-Book-Italic-101b9854afd2204c2c225e7e0d3b06bf.woff2";